var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 17,
    viewBox: "0 0 9 11",
    fill: "none",
    className: "injected-svg",
    "data-src": "/icons/new/menu-pdf.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.09 10.326H1.103a.998.998 0 0 1-.998-.998V1.346a.998.998 0 0 1 .998-.998h3.509l.014.003a.52.52 0 0 1 .13.026h.02a.21.21 0 0 1 .026.021.493.493 0 0 1 .147.1L7.942 3.49a.492.492 0 0 1 .111.18l.005.013a.49.49 0 0 1 .025.129c0 .005.001.01.003.014v.003l.002.01v5.488a.998.998 0 0 1-.998.998ZM5.306 6.335v2.494h.469V7.811h.728v-.418h-.728v-.639h.816v-.42H5.306Zm-1.846 0v2.494h.602a.833.833 0 0 0 .664-.28c.172-.219.258-.494.243-.772v-.404a1.14 1.14 0 0 0-.25-.761.817.817 0 0 0-.645-.277H3.46Zm-1.858 0v2.494h.47v-.877h.311a.74.74 0 0 0 .561-.213.808.808 0 0 0 .205-.579.86.86 0 0 0-.206-.595.699.699 0 0 0-.55-.23h-.79Zm2.993-4.99V3.84H7.09L4.595 1.346ZM4.07 8.412h-.141V6.754h.17a.357.357 0 0 1 .31.146c.073.151.105.32.09.487v.433a.84.84 0 0 1-.1.46.382.382 0 0 1-.33.131Zm-1.677-.879H2.07v-.778h.326a.237.237 0 0 1 .2.113c.054.09.08.193.075.297a.444.444 0 0 1-.074.274.25.25 0 0 1-.205.094Z",
    fill: "#949494"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuPdf);
export default __webpack_public_path__ + "static/media/menu-pdf.ae1deff15620e54f79ee5ed8f40544e8.svg";
export { ForwardRef as ReactComponent };